import React from "react";
import { calculateConcessionPercentage } from "./utils";
export const RenderProgressiveConcessionPercentage = ({ breakup, itemTypeLabel }) => {
  const concessionBreakup = calculateConcessionPercentage(breakup);
  const defaultPercentage=0
  console.log('RenderProgressiveConcessionPercentage', concessionBreakup, breakup);
  return Object.keys(itemTypeLabel)?.map((item) => {
    return (
      <div className="details-item" key={itemTypeLabel[item]}>
        <span className="label pb-1">{itemTypeLabel[item]}</span>
        <span className="value">{concessionBreakup?.[item]?`
          ${concessionBreakup?.[item]?.concessionPercentage.toFixed(2)}
        %`:`${defaultPercentage.toFixed(2)}%`}</span>
      </div>
    );
  });
};
const RenderConcessionPercentage = ({ itemTypeLabel, consession }) => {
  // debugger
  console.log('RenderConcessionPercentage', consession);
  return Object.keys(itemTypeLabel)?.map((item) => {
    return (
      <div className="details-item" key={itemTypeLabel[item]}>
        <span className="label pb-1">{itemTypeLabel[item]}</span>
        <span className="value">{`${
          Math.round(
            (consession[item]?.flAmt +
              consession[item]?.ylAmt +
              consession[item]?.ulAmt +
              consession[item]?.oAmt) *
              100
          ) / 100
        }%`}</span>
      </div>
    );
  });
};

export default RenderConcessionPercentage;
